"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./layer.component"));
__export(require("./layergroup.component"));
__export(require("./layerimage.component"));
__export(require("./layertile.component"));
__export(require("./layervector.component"));
__export(require("./layervectortile.component"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-openlayers/dist/components/layers/index.js
// module id = 43
// module chunks = 3